<template>
  <div class="shareDetailPage">
    <div class="ggInfo">
      <div class="shareInfo">
        <van-image :src="baseData.avatar" fit="cover" class="infoAvatar" />
        <div class="InfoMain">
          <span class="avatarName">{{baseData.realName}}</span>
          <div class="criticLike" @click="handleClick">
            <span class="criticLikeIcon red" v-if="baseData.isLike">
              <van-icon name="good-job" />
            </span>
            <span class="criticLikeIcon" v-else>
              <van-icon name="good-job-o" />
            </span>
          </div>
          <p class="infoText">{{baseData.content}}</p>
          <div class="imgWrap dis_flex" v-if="baseData.imgs.length!=4">
            <div
              class="img"
              v-for="(item,index) in baseData.imgs"
              :key="'dfff'+item+index"
              @click="seeImg(baseData.imgs,index)"
            >
              <van-image width="100%" height="100%" fit="cover" :src="item" />
            </div>
          </div>
          <div class="imgWrap" v-else>
            <div class="dis_flex">
              <template v-for="(item,index) in baseData.imgs">
                <div
                  class="img"
                  :key="item+baseData.id+index"
                  v-if="index==0 || index==1"
                  @click="seeImg(baseData.imgs,index)"
                >
                  <van-image width="100%" height="100%" fit="cover" :src="item" />
                </div>
              </template>
            </div>
            <div class="dis_flex">
              <template v-for="(item,index) in baseData.imgs">
                <div
                  class="img"
                  :key="item+baseData.id+index"
                  v-if="index==2 || index==3"
                  @click="seeImg(baseData.imgs,index)"
                >
                  <van-image width="100%" height="100%" fit="cover" :src="item" />
                </div>
              </template>
            </div>
          </div>
          <div class="createTime clearfix">
            <p>
              {{baseData.createTime}}
              <!-- <a href="javascript:void(0);" class @click="delInfo">删除</a> -->
            </p>
          </div>
        </div>
      </div>
      <div class="commentBox">
        <span class="sanjiao"></span>
        <div class="likeBox" v-if="likeList.length!='0'">
          <span class="aixin">
            <van-icon name="like-o" />
          </span>
          <ul>
            <li class="likeList">
              <span>{{likeList.join(',')}}</span>
            </li>
          </ul>
        </div>
        <discuss-box :ktId="baseData.id" :allowComment="baseData.allowComment" />
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const discussBox = () => import("@/components/common/discussBox");
import { mapState, mapMutations } from "vuex";
import { timeago, Showswiper, getCurData } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "shareDetail",
  data() {
    return {
      baseData: {
        avatar: "",
        content: "",
        createTime: "",
        gender: "",
        id: "",
        imgs: [],
        realName: "",

        rowNum: null,
        title: null,
      },
      commonId: "",
      likeList: [], //点赞列表
      clientType: getDeviceType(), //手机类型
    };
  },
  components: { discussBox },
  mounted() {
    this.commonId = this.$route.query.commonId;
    this.initPage();
    this.getLikeList();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
      this.setShowLoad(false);
      _this.$api.userCenter.user.noteBox
        .noteDetails(_this.commonId)
        .then((res) => {
          if (res.code == "1") {
            _this.baseData = res.data;
            this.$set(_this.baseData, "allowComment", true);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    seeImg(item, img) {
      //放大图片
      Showswiper(item, img);
       if (this.clientType == "android") {  //隐藏评论框
        window.android.getInfo(114);
      } else {
        //IOS
        // window.webkit.messageHandlers.hideComment.postMessage();
      }
    },
    delInfo() {
      //删除记事分享
      let _this = this;
      _this.$dialog
        .alert({
          title: "提示",
          message: "是否确认删除改分享",
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
      console.log(this.baseData);
    },
    handleClick(data) {
      let _this = this;

      //已经点过赞了
      _this.$api.userCenter.user.noteBox
        .noteLike(_this.baseData.id)
        .then((res) => {
          if (res.code == "1") {
            _this.getLikeList();
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });

      _this.baseData.isLike = !_this.baseData.isLike;
    },
    getLikeList() {
      let _this = this;
      _this.$api.userCenter.user.noteBox
        .noteLikeList(_this.commonId)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.likeList = [];
            res.data.forEach((item) => {
              _this.likeList.push(item.realName);
            });
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.shareDetailPage {
  width: 100%;
  min-height: #fff;
  padding-top: 12px;
  .ggInfo {
    width: 100%;
    padding: 0 16px;
  }
  .shareInfo {
    width: 100%;
    padding-left: 54px;
    position: relative;
    .infoAvatar {
      width: 42px;
      height: 42px;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      img {
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
      }
    }
    .InfoMain {
      padding-top: 2px;
      position: relative;
      .avatarName {
        height: 20px;
        font-size: 16px;
        font-family: "PingFangSC-Medium", "PingFang SC";
        font-weight: 600;
        color: #3c78f9;
        line-height: 22px;
      }
      .infoText {
        min-height: 17px;
        font-size: 15px;
        font-family: "PingFangSC-Regular", "PingFang SC";
        font-weight: 400;
        color: #595959;
        line-height: 17px;
        overflow: hidden;
        margin:11px 0;
      }
      .imgWrap {
        width: 100%;
        flex-wrap: wrap;
        
        .img {
          width: 33.33%;
          padding-right: 6px;
          padding-bottom: 6px;
          border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          img {
            width: 100%;
            max-height: 75px;
            border-radius: 5px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
          }
        }
      }
      .createTime {
        margin-top: 10px;
        font-size: 14px;
        font-family: " PingFangSC-Regular", "PingFang SC";
        font-weight: 400;
        color: #9e9e9e;
        line-height: 17px;
        a {
          display: inline-block;
          margin-left: 15px;
          color: #3c78f9;
        }
      }
      .criticLike {
        position: absolute;
        bottom: 0;
        right: 10px;
        span {
          display: block;
        }
        .criticLikeIcon {
          i {
            font-size: 18px;
            color: #000;
          }
        }
        .criticCount {
          font-size: 10px;
          color: #000;
          text-align: center;
        }
        .criticLikeIcon.red {
          i {
            color: #21bc9c;
          }
        }
      }
    }
  }
  .commentBox {
    margin-top: 10px;
    width: 100%;
    .likeBox {
      padding: 0 30px 0 30px;
      position: relative;
      .aixin {
        width: 20px;
        display: inline-block;
        text-align: center;
        position: absolute;
        top: 0;
        left: 9px;
        i {
          font-size: 16px;
          color: #3c78f9;
          line-height: 20px;
        }
      }
      ul {
        display: inline-block;
        li.likeList {
          color:#3c78f9;
          min-height: 20px;
          line-height: 20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>